import { createSelector } from 'reselect';

export const selectRoles = (state) => state.get('entities').role;

export const selectRoleById = createSelector(
  selectRoles,
  (state, roleId) => roleId,
  (roles, roleId) => roles.get(roleId)
);
